module.exports = __webpack_public_path__ + "static/media/ios-rating.d651121a.png";